<template>
  <div class="gui" :class="{ 'gui-visible': visible }" ref="gui">
    <GUIIndex
      :restrooms="restrooms"
      :selected="selected"
      @randomize="emitRandomize"
      @update:selectedRestroom="emitSelection"
    />
    <div class="gui-resize-handle" @mousedown="startResize"></div>
  </div>
</template>

<script>
  import GUIIndex from './GUI-index.vue';

  export default {
    name: 'GUI',
    components: {
      GUIIndex,
    },
    props: {
      restrooms: {
        type: Array,
        required: true, // Array of restrooms passed from App.vue
      },
      selectedRestroom: {
        type: Object,
        default: null, // Allow null for the initial state
      },
      visible: {
        type: Boolean,
        required: true, // Determines if the GUI is visible
      },
    },
    data() {
      return {
        selected: this.selectedRestroom || {}, // Default to an empty object if null
      };
    },
    watch: {
      selectedRestroom: {
        immediate: true,
        handler(newRestroom) {
          this.selected = newRestroom;
          this.scrollToActiveRestroom();
        },
      },
    },
    methods: {
      emitSelection(newRestroom) {
        this.$emit('update:selectedRestroom', newRestroom);
      },
      emitRandomize() {
        this.$emit('randomize');
      },
      scrollToActiveRestroom() {
        if (!this.selected || !this.selected.name) return; // Skip if selected is null or undefined
        this.$nextTick(() => {
          const activeItem = this.$refs.dropdownItems?.find((item) =>
            item.textContent.includes(this.selected.name.toUpperCase())
          );
          if (activeItem) {
            activeItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      },
      startResize(e) {
        document.body.style.cursor = 'col-resize';
        this.$refs.gui.style.cursor = 'col-resize'; // Ensure cursor on the panel
        document.body.style.userSelect = 'none'; // Prevent text selection
        const gui = this.$refs.gui;
        const startX = e.clientX;
        const startWidth = gui.offsetWidth;

        const doDrag = (event) => {
          let newWidth = startWidth + (event.clientX - startX);
          if (newWidth < 300) newWidth = 300;
          gui.style.width = newWidth + 'px';
        };

        const stopDrag = () => {
          document.body.style.cursor = '';
          this.$refs.gui.style.cursor = ''; // Reset panel cursor
          document.body.style.userSelect = ''; // Re-enable text selection
          window.removeEventListener('mousemove', doDrag);
          window.removeEventListener('mouseup', stopDrag);
        };

        window.addEventListener('mousemove', doDrag);
        window.addEventListener('mouseup', stopDrag);
      },
    },
    mounted() {
      this.scrollToActiveRestroom();
    },
  };
</script>

<style scoped>
  .gui {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 300px;
    min-width: 300px;
    max-width: 100vw;
    padding: 10px;
    z-index: 100;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;

    background: rgba(255, 255, 255, 0.11);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.13);
    overflow-x: calc(100% - 20px); /* Adjust for padding */
  }

  .gui.gui-visible {
    transform: translateX(0);
  }

  .gui-resize-handle {
    position: absolute;
    top: 0;
    right: -5px;
    width: 3px; /* wider for easier grabbing */
    height: 100%;
    cursor: col-resize;
    z-index: 9999; /* ensure it's above all content */
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: all;
    border-left: 2px solid rgb(255, 255, 255, 0.3);
  }

  .gui-resize-handle:hover {
    border-left: 4px solid rgb(255, 255, 255, 0.4);
    cursor: col-resize;
  }

  @media (max-width: 600px) {
    .gui {
      width: 95vw !important;
      min-width: unset !important;
    }
    .gui-resize-handle {
      display: none !important;
    }
  }
</style>
